<template>
  <div class="message_wrap bg_white pl16 pr16 pt15 pb16">
    <div v-if="!confirm[0] && !confirm[1]" class="">
      <h2 class="message_title ab color_red">口座引き落とし払いをご利用の方</h2>
      <p class="message_text ab color_red">振替依頼書のご提出が必要です。振替依頼書の郵送を希望される方は、以下に<span class="check"></span>してください。</p>
      <p class="message_text ab color_red">なお、口座引き落としのお手続きには約2ヶ月かかり、お手続きまでは代金引換でのお届けとなりますのでご了承ください。</p>
      <div class="bank_transport">
        <input v-model="bankData.transferRequest" :checked="bankData.transferRequest" class="kodomo_check" type="checkbox" id="bank" name="checkbox01">
        <label for="bank" class="checkbox01 ab">振替依頼書の郵送を希望する</label>
      </div>
    </div>

    <div v-else class="c5a ab bdb pb10">
      振替依頼書の郵送を希望{{ bankData.transferRequest ? 'する' : 'しない' }}
    </div>
  </div>

</template>

<script>
export default {
  props: ['bankData', 'confirm'],
}
</script>

<style lang="css" scoped>
.color_red {
  color: #FF3A3A;
}
.message_title {
  border-bottom: 1px solid  #FF3A3A;
  display: inline-block;
}
.message_text {
  font-size: 14px;
  margin-top: 15px;
}
.bank_transport {
  margin-top: 30px;
}
.check {
  background: #00C2FF;
  border: 1px solid #00C2FF;
  border-radius: 2px;
  display: inline-block;
  height: 16px;
  position: relative;
  vertical-align: text-top;
  width: 16px;
}
.check::before {
  bottom: 3px;
  border-left: 3px solid #fff;
  border-bottom: 3px solid #fff;
  content: '';
  height: 4px;
  left: 0px;
  margin: auto;
  transform: rotate(-45deg);
  position: absolute;
  right: 0;
  top: 0;
  width: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/bank/Message.vue